import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {onboardingSessions} from './api_session';
import {handleMessage} from './general';

const AttachmentOptions = priority.netitems.form.AttachmentOptions;

export const getCompanyData = async (form, cols) => {
    const ColumnID = cols.Columns.find(col => col.Name === 'COMPDES')?.ID;

    try {
        const res = await wcfclient.recordsFetch(
            new priority.netitems.form.FetchRq({
                Session: form.Session,
                Properties: getAdditionalProps(),
                Attachments: AttachmentOptions.Attach_Data,
                Filters: [
                    {
                        Condition: [
                            {
                                ColumnID,
                                Operator: priority.netitems.shared.ComparisonOperator.Eq,
                                Values: ['*']
                            }
                        ]
                    }
                ]
            })
        );

        handleMessage(res.Messages, form.Session);

        return res;
    } catch (e) {
        onboardingSessions.removeFormByKey(form.Fname);

        throw Error(e as string);
    }
};
